export default __webpack_public_path__ + "media/images/mailer-new/welcome-icons/edit_profile_step-on-57e31b0ecbae9c347703c49fc0fa1073.png";